import type { PlayJoinPolicy } from '@court-sync/shared';
import type { OrgRegisterMode } from '@/contexts/OrgRegisterDialogContext';

/** Whether the join policy can include academy students. */
export function playEventNeedsAcademyStudent(joinPolicy: PlayJoinPolicy): boolean {
  return joinPolicy === 'students_only' || joinPolicy === 'members_and_students';
}

/**
 * Pick org registration mode for play-event join CTAs.
 * Club signup only creates a platform user — academy signup is required for student-only events.
 */
export function resolvePlayEventRegisterMode(
  joinPolicy: PlayJoinPolicy,
  hasAcademy: boolean
): OrgRegisterMode {
  if (!hasAcademy) return 'club';
  if (joinPolicy === 'members_only') return 'club';
  if (joinPolicy === 'students_only') return 'academy';
  if (joinPolicy === 'open') return 'club';
  return 'academy';
}
